/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import "./index.scss";

import { duration } from "utils";
// ui
import { Row, Col, Card, Progress } from "antd";

// animations
import { Fade } from "react-reveal";

// components
import DoughnutChart from "../../../common/DoughnutChart";

// images
// import AsSeenImg1 from "../../../assets/images/as-seen1.png";
// import AsSeenImg2 from "../../../assets/images/as-seen2.png";
// import AsSeenImg3 from "../../../assets/images/as-seen3.png";
// import AsSeenImg4 from "../../../assets/images/as-seen4.png";
// import AsSeenImg5 from "../../../assets/images/as-seen5.png";
// import AsSeenImg6 from "../../../assets/images/as-seen6.png";
// import AsSeenImg7 from "../../../assets/images/as-seen7.png";
// import AsSeenImg8 from "../../../assets/images/as-seen8.png";

import IconMess from "../../../assets/icons/messages.svg";
import IconShow from "../../../assets/icons/show.svg";

import { stayUpData, colors, schedules } from "./data";

const { Meta } = Card;

const Structured = (props) => {
  return (
    <div className="structured">
      <div className="structuredContent">
        <div className="structuredTimes">
          <h4 className="title">The allocation of funds raised</h4>

          <div className="infoGraph viewDesktop1">
            <DoughnutChart />
          </div>

          <div className="viewMobileSmall allProgress">
            {schedules.map((item, i) => (
              <div key={i} className="progressItem">
                <Progress
                  trailColor="rgba(0, 0, 0, 0.1)"
                  strokeColor={colors[i]}
                  percent={item.percent}
                  showInfo={false}
                  strokeWidth={4}
                />
                <h5>{item.title}</h5>
                <h4>{item.value}</h4>
              </div>
            ))}
          </div>

          {/* <Row gutter={20}>
            {schedules &&
              schedules.map((item, i) => (
                <Col key={i} md={8} xs={24}>
                  <Fade bottom duration={300}>
                    <div className={`timeBox box${i + 1}`}>
                      <h4>{item.title}</h4>
                      <h3>{item.value}</h3>
                    </div>
                  </Fade>
                </Col>
              ))}
          </Row> */}
        </div>

        <div className="smartContract">
          <Row gutter={24}>
            <Col lg={12} xs={24}>
              <Fade bottom duration={duration}>
                <h1>
                  We are deploying a self terminating{" "}
                  <a href="#">smart contract.</a>
                </h1>
              </Fade>
            </Col>
            <Col lg={12} xs={24}>
              <Fade bottom duration={duration}>
                <div className="other">
                  <p className="description">
                    Early unlocks are taxed. Later stage unlocks are rewarded.
                    Partial amounts cannot be redeemed. The dates commence from
                    September the 1st 2021. As an example, should you wish to
                    unlock in the first month of September, you will pay 60% tax
                    which is automatically deducted as the contract releases
                    your tokens. The taxed tokens remain within the protocol,
                    distributed to participants who commit to longer vesting
                    periods.
                  </p>

                  <div className="cardView">
                    <p>
                      At the expiry of the full term, all uncollected tokens are
                      airdropped to users who have held PCOG tokens in their
                      wallet for longer than 6 months.
                    </p>
                  </div>
                </div>
              </Fade>
            </Col>
          </Row>
        </div>

        {/* <div className="asSeenOn">
          <h4 className="title">As seen on</h4>

          <div className="listCompanies">
            <Row gutter={0}>
              <Col lg={6} md={12} xs={24}>
                <div className="companyItem nonLeft">
                  <img alt="" src={AsSeenImg1} />
                </div>
              </Col>
              <Col lg={6} md={12} xs={24}>
                <div className="companyItem">
                  <img alt="" src={AsSeenImg2} />
                </div>
              </Col>
              <Col lg={6} md={12} xs={24}>
                <div className="companyItem">
                  <img alt="" src={AsSeenImg3} />
                </div>
              </Col>
              <Col lg={6} md={12} xs={24}>
                <div className="companyItem noneRight ">
                  <img alt="" src={AsSeenImg4} />
                </div>
              </Col>
              <Col lg={6} md={12} xs={24}>
                <div className="companyItem noneBot">
                  <img alt="" src={AsSeenImg5} />
                </div>
              </Col>
              <Col lg={6} md={12} xs={24}>
                <div className="companyItem noneBot">
                  <img alt="" src={AsSeenImg6} />
                </div>
              </Col>
              <Col lg={6} md={12} xs={24}>
                <div className="companyItem noneBot">
                  <img alt="" src={AsSeenImg7} />
                </div>
              </Col>
              <Col lg={6} md={12} xs={24}>
                <div className="companyItem noneBot noneRight">
                  <img alt="" src={AsSeenImg8} />
                </div>
              </Col>
            </Row>
          </div>
        </div> */}

        <div className="stayUp">
          <h4 className="title">Stay up to date</h4>

          <Row gutter={37}>
            {stayUpData.map((item, i) => (
              <Col key={i} md={8}>
                <Card
                  cover={
                    <a href={item.link} target="_blank" rel="noreferrer">
                      <img alt="" src={item.image} />
                    </a>
                  }
                  actions={[
                    <a href="#" className="messages">
                      <img alt="" src={IconMess} />
                      <span>{item.messages}</span>
                    </a>,
                    <a href="#" className="show">
                      <img alt="" src={IconShow} />
                      <span>{item.viewed}</span>
                    </a>,
                  ]}
                >
                  <Meta
                    title={
                      <>
                        <h6 className="date">{item.date}</h6>
                        <h4>
                          <a href={item.link} target="_blank" rel="noreferrer">
                            {item.title}
                          </a>
                        </h4>
                      </>
                    }
                    description={item.decs}
                  />
                </Card>
              </Col>
            ))}
          </Row>
        </div>
      </div>
    </div>
  );
};

export default Structured;
